import React from 'react';
import { Link } from 'gatsby';
import parse from 'html-react-parser';
import { useWipAuthors } from '../../../hooks/use-wip-authors';
import { getPostAuthors } from '../../../model/author';
import { getPostPath } from '../../../model/post';
import { AuthorLink } from '../index';
import classNames from 'classnames';

const Card = ({
  post: {
    slug,
    title,
    excerpt,
    tghpwipArticleLabel,
    tghpwipArticleAuthor: authorIds,
    tghpwipArticleSmallCapsTitle: useSmallCapsTitle,
  },
}) => {
  const allAuthors = useWipAuthors();
  const postAuthors = getPostAuthors(authorIds, allAuthors);

  return (
    <article
      className={classNames([
        'article-card',
        !!Number(useSmallCapsTitle) && 'article-card--small-caps-title',
      ])}
    >
      <header className="article-card__head">
        <Link to={getPostPath(slug)}>
          <h3 className="article-card__head-title">{title}</h3>
        </Link>
        <div className="article-card__head-author">
          Words by&nbsp;
          {postAuthors.map((author, idx) => (
            <AuthorLink author={author} postAuthors={postAuthors} index={idx} key={idx} />
          ))}
        </div>
      </header>
      <div className="article-card__body">
        <div className="article-card__body-excerpt">{parse(excerpt)}</div>
        <Link to={getPostPath(slug)} className="article-card__body-read-more">
          Read more {parse(`&#8594`)}
        </Link>
      </div>
      {tghpwipArticleLabel && (
        <footer className="article-card__foot">
          <div className="article-card__foot-label">{tghpwipArticleLabel}</div>
        </footer>
      )}
    </article>
  );
};

export default Card;
